import { breakpoints } from "@repo/fika-design-system/breakpoints"
import { createMemo } from "solid-js"
import { imageClass } from "./responsive-image.css"

const CDN_ASSETS_URL = import.meta.env.VITE_CDN_ASSETS_URL
const FOLDER = "static"

export function ResponsiveImage(props: { src: string; alt: string }) {
  const imgUrl = createMemo(
    () => `${CDN_ASSETS_URL}/${FOLDER}/${props.src}.jpg`,
  )

  return (
    <img
      srcset={`
        ${imgUrl()}?width=200 200w,
        ${imgUrl()}?width=400 400w,
        ${imgUrl()}?width=800 800w,
        ${imgUrl()}?width=1000 1000w,
        ${imgUrl()}?width=1200 1200w
      `}
      sizes={`
        ${breakpoints.s} 200px,
        ${breakpoints.m} 400px,
        ${breakpoints.l} 800px,
        ${breakpoints.xxl} 1000px,
        1200px,
      `}
      class={imageClass}
      alt={props.alt}
    />
  )
}
